// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"90":"b71e4175","240":"95681438","453":"42e41f5c","565":"a944071f","648":"13875817","885":"9bf8376b","893":"3617cfc9","992":"ca39a185"}[chunkId] + ".chunk.js";
};